<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.admin"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center px-8 pt-6">
        <img
          class="w-24"
          src="assets/images/logo/logo-text-on-dark.svg"
          alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div
  class="dark:bg-card flex w-full min-w-0 flex-auto flex-col items-center bg-gray-200">
  <!-- Header -->
  <div
    class="flex-0 z-49 relative flex h-16 w-full flex-col justify-center overflow-hidden shadow dark:shadow-none print:hidden sm:h-20 md:h-36">
    <!-- Top bar -->
    <div
      class="dark relative flex w-full flex-auto justify-center bg-gray-800 px-4 dark:bg-gray-900 md:px-8">
      <div class="max-w-360 flex h-16 w-full items-center sm:h-20">
        <!-- Logo -->
        @if (!isScreenSmall) {
          <div class="flex items-center">
            <img
              class="w-24"
              src="assets/images/logo/logo-text-on-dark.svg"
              alt="Logo image" />
          </div>
        }
        <!-- Navigation toggle button -->
        @if (isScreenSmall) {
          <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
          </button>
        }
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
          <languages />
          <fuse-fullscreen class="hidden md:block" />
          <search [appearance]="'bar'" />
          <shortcuts />
          <messages />
          <notifications />
          <button
            class="lg:hidden"
            mat-icon-button
            (click)="quickChat.toggle()">
            <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'" />
          </button>
          <user />
        </div>
      </div>
    </div>
    <!-- Bottom bar -->
    @if (!isScreenSmall) {
      <div
        class="bg-card flex flex-auto justify-center px-4 dark:bg-gray-700 md:px-8">
        <div class="max-w-360 relative flex h-16 w-full items-center">
          <fuse-horizontal-navigation
            class="-mx-4"
            [name]="'mainNavigation'"
          [navigation]="navigation.horizontal" />
        </div>
      </div>
    }
  </div>

  <!-- Content -->
  <div class="flex w-full flex-auto justify-center sm:p-6 md:p-8">
    <div
      class="bg-default sm:max-w-360 flex w-full flex-auto flex-col sm:overflow-hidden sm:rounded-lg sm:shadow-lg">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet />
      }
    </div>
  </div>

  <!-- Footer -->
  <div
    class="flex-0 z-49 bg-card relative flex w-full justify-center border-t px-6 print:hidden md:px-8">
    <div class="max-w-360 flex h-14 w-full items-center sm:h-20">
      <span class="text-secondary font-medium"
        >Fuse &copy; {{ currentYear }}</span
        >
      </div>
    </div>
  </div>

  <!-- Quick chat -->
  <quick-chat #quickChat="quickChat" />
